import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-users.service";

export const useAdminUsers = createUseData(
    service.getUsers,
)